<template>
  <div v-if="selectedPlan !== null && selectedPlan !== undefined">
    <v-dialog v-model="dialog" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">
          {{ $t("globals.cancel_wizard") }}
        </v-card-title>
        <v-card-text>
          {{
            $t(
              "views.billingwizard.if_you_exit_the_wizard_any_changes_made_so_far"
            )
          }}
        </v-card-text>
        <v-card-actions>
          <v-btn color text @click="dialog = false">
            {{ $t("globals.keep_working") }}
          </v-btn>
          <v-btn color="primary" @click="cancel()">
            {{ $t("globals.cancel_anyway") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="skipDialog" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">
          {{ $t("globals.warning") }}
        </v-card-title>
        <v-card-text>
          {{
            $t(
              "views.billingwizard.skip_warning_text"
            )
          }}
        </v-card-text>
        <v-card-actions>
          <v-btn color text @click="skipDialog = false" :disabled="calculating">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="primary" @click="skipCalculation"
          :loading="calculating">
            {{ $t("views.billingwizard.skip") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="with-margin" v-if="term !== null">
      <material-card
        :title="
          $t(
            'views.billingwizard.premiums_&_billing_calculation_for_{0}_term',
            [trans(term, 'Name')]
          ) +
          ' (' +
          term.StartDate.split('T')[0].replace(/-/g, '/') +
          ' - ' +
          term.EndDate.split('T')[0].replace(/-/g, '/') +
          ')'
        "
        :color="$vuetify.theme.themes.light.secondary"
        icon="assistant"
      >
        <v-card-text>
          {{
            $t(
              "views.billingwizard.you_are_few_steps_away_from_calculating_premiums_&_billing_{0}",
              [trans(selectedPlan, "Name")]
            )
          }}
        </v-card-text>
        <v-stepper v-model="e6" vertical>
          <v-stepper-step :complete="e6 > 1" step="1">
            {{ $t("views.billingwizard.update_members") }}
            <small>
              {{
                $t(
                  "views.billingwizard.edit_the_members_information_if_required_for_the_calculation"
                )
              }}
            </small>
          </v-stepper-step>
          <v-stepper-content step="1">
            <v-card>
              <members-management-table
                ref="membersTable"
                :expandable="false"
                @setMembers="members = true"
                :identifier="selectedPlan.Id + '_membersTable_billing'"
              ></members-management-table>
              <v-card-actions>
                <v-flex>
                  <v-btn text @click="dialog = true">
                    {{ $t("globals.cancel") }}
                  </v-btn>
                  <v-btn
                    :loading="loading"
                    :disabled="!members"
                    color="primary"
                    @click="e6 = 2"
                  >
                    {{ $t("globals.continue") }}
                  </v-btn>
                </v-flex>
              </v-card-actions>
            </v-card>
          </v-stepper-content>

          <v-stepper-step :complete="e6 > 2" step="2">
            {{
              $t(
                "views.billingwizard.review_and_verify_members_data_for_calculation"
              )
            }}
            <small>
              {{
                $t(
                  "views.billingwizard.the_table_below_presents_the_members_data_that_will_be"
                )
              }}
            </small>
          </v-stepper-step>

          <v-stepper-content step="2">
            <v-card>
              <v-container fluid>
                <v-row>
                  <v-col>
                    <v-banner
                      v-if="!membersForTerm && loaded && !adjExist"
                      color="error"
                      icon="error_outline"
                      elevation="0"
                      icon-color="white"
                    >
                      {{
                        $t(
                          "views.billingwizard.no_active_members_found_for_this_billing_period"
                        )
                      }}
                    </v-banner>
                  </v-col>
                </v-row>
              </v-container>
              <material-card
                :title="$t('views.billingwizard.members_for_calculation')"
                :color="$vuetify.theme.themes.light.secondary"
                icon="folder_special"
                v-if="
                  membersForTermHeaders !== null &&
                  membersForTermHeaders !== undefined
                "
              >
                <pbas-data-table
                  :exporters="$exporters"
                  v-if="$refs.membersTable"
                  ref="membersForTermTable"
                  :dataProvider="membersProvider"
                  fileNamePrefix="term-members"
                  @itemsChanged="setMembersForTerm($event)"
                  :identifier="selectedPlan.Id + '_membersForTermTable'"
                  @error="error = $event; tableError=true"
                  :noSearch="true"
                ></pbas-data-table>
              </material-card>

              <v-card-actions>
                <v-flex>
                  <v-btn text @click="dialog = true">
                    {{ $t("globals.cancel") }}
                  </v-btn>
                  <v-btn text @click="e6 = 1">
                    {{ $t("globals.back") }}
                  </v-btn>
                  <v-btn
                    color="primary"
                    :disabled="!membersForTerm && !adjExist && !tableError"
                    @click="e6 = 3"
                  >
                    {{ $t("globals.continue") }}
                  </v-btn>
                  <v-btn
                    text
                    @click="skipDialog=true"
                  >
                    {{ $t("views.billingwizard.skip") }}
                  </v-btn>
                </v-flex>
              </v-card-actions>
            </v-card>
          </v-stepper-content>

          <v-stepper-step :complete="e6 > 3" step="3">
            {{
              $t(
                "views.billingwizard.review_adjustments_and_perform_calculation"
              )
            }}
            <small>
              {{
                $t(
                  "views.billingwizard.handle_all_pending_adjustments_then_press_continue_to_proceed_with"
                )
              }}
            </small>
          </v-stepper-step>

          <v-stepper-content step="3">
            <v-card>
              <div v-if="calculateMessage === ''">
                <material-card
                  :title="$t('views.billingwizard.adjustments')"
                  :color="$vuetify.theme.themes.light.secondary"
                  icon="adjust"
                  v-if="hasPendingAdjustments"
                >
                  <pbas-data-table
                    :exporters="$exporters"
                    ref="adjTable"
                    :dataProvider="adjProvider"
                    fileNamePrefix="adjustments"
                    :selectActions="adjSelectActions"
                    :rowActions="adjRowActions"
                    @itemsChanged="setAdjustments($event)"
                    identifier="adjTable"
                    @error="error = $event"
                  ></pbas-data-table>
                </material-card>
              </div>
              <div v-else>
                <v-banner
                  :icon="calculateIcon"
                  elevation="0"
                  :icon-color="calculateColor"
                >
                  {{ calculateMessage }}
                </v-banner>
              </div>
              <v-container
                v-if="!hasPendingAdjustments && calculateColor != 'success'"
              >
                <v-row>
                  <v-banner icon elevation="0" icon-color="white">
                    <span>
                      {{ $t("views.billingwizard.no_adjustments") }}
                    </span>
                  </v-banner>
                  <v-btn
                    :loading="calculating"
                    dark
                    color="success"
                    @click="tryCalculate(false)"
                  >
                    {{ $t("views.billingwizard.calculate") }}
                  </v-btn>
                </v-row>
                <v-row></v-row>
              </v-container>
              <v-card-actions>
                <v-flex>
                  <v-btn
                    :disabled="calculating || calculateColor === 'success'"
                    text
                    @click="dialog = true"
                  >
                    {{ $t("globals.cancel") }}
                  </v-btn>
                  <v-btn
                    :disabled="calculating || calculateColor === 'success'"
                    text
                    @click="e6 = 2"
                  >
                    {{ $t("globals.back") }}
                  </v-btn>
                  <v-btn
                    color="primary"
                    @click="e6 = 4"
                    :disabled="calculating || !calculated"
                  >
                    {{ $t("globals.continue") }}
                  </v-btn>
                </v-flex>
              </v-card-actions>
            </v-card>
          </v-stepper-content>

          <v-stepper-step :complete="e6 > 4" :step="4">
            {{
              $t(
                "views.billingwizard.premiums_&_billing_calculation_reports_for_{0}_for_plan_{1}",
                [trans(term, "Name"), trans(selectedPlan, "Name")]
              )
            }}
            <small>
              {{
                $t(
                  "views.billingwizard.navigate_to_the_produced_calculation_results_and_handle_the_reports"
                )
              }}
            </small>
          </v-stepper-step>
          <v-stepper-content :step="4">
            <v-card>
              <v-card-text>
                <get-reports
                  ref="getReports"
                  v-if="calculated === true && e6 > 3"
                  :term="term"
                  :reportId="reportId"
                ></get-reports>
              </v-card-text>
              <v-card-actions>
                <v-flex>
                  <v-btn text @click="dialog = true">
                    {{ $t("globals.cancel") }}
                  </v-btn>
                  <v-btn color="primary" @click="finish()">
                    {{ $t("globals.finish") }}
                  </v-btn>
                </v-flex>
              </v-card-actions>
            </v-card>
          </v-stepper-content>
        </v-stepper>
      </material-card>
      <v-snackbar
        v-model="snackbar"
        :color="color"
        :multi-line="mode === 'multi-line'"
        :timeout="timeout"
        :vertical="mode === 'vertical'"
      >
        {{ $t(message) }}
        <v-btn dark text @click="snackbar = false">
          {{ $t("globals.close") }}
        </v-btn>
      </v-snackbar>
      <error-handler :error="error"></error-handler>
    </div>
  </div>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import MembersManagementTable from "../components/MembersManagementTable";
import GetReports from "../components/GetReports";
import ErrorHandler from "../components/ErrorHandler";
import { ODataProvider as PbasOData } from "pbas-vue-components";
import AdjustmentsHeaders from "../headers/Adjustments";
import { ODataHeader, ODataInteger, ODataString } from "pbas-vue-components";
import { locker } from "../mixins/locker";
import { translate2 } from "../trans2";
import AutoSelect from "../components/AutoSelect";
import { planSetter } from "../mixins/planSetter";

import { mapGetters, mapActions } from "vuex";

export default {
  name: "billing-wizard",
  components: {
    MembersManagementTable,
    GetReports,
    ErrorHandler,
    AutoSelect,
  },
  mixins: [locker, planSetter],
  data() {
    return {
      adjExist: false,
      reportId: null,
      loaded: false,
      valid: true,
      membersAdded: [],
      membersUpdated: [],
      error: null,
      adjProvider: undefined,
      membersProvider: undefined,
      membersForTerm: false,
      membersForTermHeaders: null,
      members: false,
      calculateMessage: "",
      calculateIcon: "",
      calculateColor: "",
      hasPendingAdjustments: true,
      snackbar: false,
      color: "",
      mode: "",
      timeout: 2500,
      message: "",
      loading: false,
      calculated: false,
      calculating: false,
      saving: false,
      adjSelectActions: [
        {
          name: "approve",
          title: "views.billingwizard.approve",
          icon: "check_circle_outline",
          handler: () => this.adjustmentActions("approve"),
        },
        {
          name: "reject",
          title: "views.billingwizard.reject",
          icon: "cancel",
          handler: () => this.adjustmentActions("reject"),
        },
        {
          name: "archive",
          title: "views.billingwizard.archive",
          icon: "archive",
          handler: () => this.adjustmentActions("archive"),
        },
        {
          name: "postpone",
          title: "views.billingwizard.postpone",
          icon: "timelapse",
          handler: () => this.adjustmentActions("postpone"),
        },
      ],
      adjRowActions: [
        {
          name: "approve",
          title: "views.billingwizard.approve",
          icon: "check_circle_outline",
          handler: (item) => this.adjustmentAction(item, "approve"),
        },
        {
          name: "reject",
          title: "views.billingwizard.reject",
          icon: "cancel",
          handler: (item) => this.adjustmentAction(item, "reject"),
        },
        {
          name: "archive",
          title: "views.billingwizard.archive",
          icon: "archive",
          handler: (item) => this.adjustmentAction(item, "archive"),
        },
        {
          name: "postpone",
          title: "views.billingwizard.postpone",
          icon: "timelapse",
          handler: (item) => this.adjustmentAction(item, "postpone"),
        },
      ],
      // adjClickFunctions: {
      //   sinClicked: item => this.sinClickedFunc(item)
      // },
      // adjDisplayFunctions: {
      //   firstNameDisplayFunc: item => item.Member.FirstName,
      //   lastNameDisplayFunc: item => item.Member.LastName,
      //   sinDisplayFunc: item => item.Member.SINCERT,
      //   coverageDisplayFunc: item => item.Coverage.Name,
      //   originalTermDisplayFunc: this.originalTermDisplayFunc
      // },
      term: null,
      csvOptions: {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      },
      dialog: false,
      e6: 1,
      adjustmentsHeaders: null,
      editedIndex: -1,
      editedItem: {
        HasDefaultCoverage: true,
        EffectiveDate: null,
      },
      defaultItem: {
        HasDefaultCoverage: true,
        EffectiveDate: null,
      },
      skipDialog: false,
      tableError: false
    };
  },
  computed: {
    ...mapGetters("common", ["language"]),
    ...mapGetters("plansMembers", { columnsDropDownOptions: "options" }),
    ...mapGetters("plansMembers", { planParameters: "planOptions" }),
    ...mapGetters("auth", ["user"]),
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("common", ["messages"]),

    reportOptions: function () {
      var reportOptions = [];
      if (this.planParameters.HasCommissions) {
        reportOptions.push("Commissions");
      }
      if (this.planParameters.HasPremiums) {
        reportOptions.push("Premiums");
      }
      if (this.planParameters.HasBilling) {
        reportOptions.push("Billing");
      }
      if (this.planParameters.HasRemittances) {
        reportOptions.push("Remittances");
      }
      return reportOptions;
    },
    adjustmentsOdata: function () {
      return {
        url:
          "plans/" +
          this.selectedPlan.Id +
          "/term/" +
          this.term.Id +
          "/members/adjustments",
        prefilter: "Status eq 'Pending'",
      };
    },
    membersForTermOdata: function () {
      return {
        url:
          "plans/" + this.selectedPlan.Id + "/membersForTerm/" + this.term.Id,
      };
    },
    successMessage: function () {
      return this.$t("views.billingwizard.calculation_succeeded");
    },
    failMessage: function () {
      return this.$t("views.billingwizard.calculation_failed");
    },
  },
  watch: {
    e6: {
      async handler(v) {
        switch (v) {
          case 1: {
            this.$refs.membersTable.getDataAsync();
            break;
          }
          case 2: {
            this.loaded = false;
            if (this.membersProvider) {
              this.$refs.membersForTermTable.getDataAsync();
            } else {
              this.membersProvider = new PbasOData(
                this.$axiosHttp,
                this.membersForTermOdata.url,
                this.membersForTermHeaders
              );
            }
            try {
              this.adjExist = (
                await this.adjustmentsExist({
                  planId: this.selectedPlan.Id,
                  termId: this.term.Id,
                })
              ).data.value;
            } catch (error) {
              this.error = error;
            }
            break;
          }
          case 3: {
            this.hasPendingAdjustments = true;
            this.calculateMessage = "";
            this.calculateColor = "";
            this.$forceUpdate();
            if (!this.adjProvider) {
              this.adjustmentsHeaders = AdjustmentsHeaders;
              this.adjProvider = new PbasOData(
                this.$axiosHttp,
                this.adjustmentsOdata.url,
                this.adjustmentsHeaders
              );
              this.adjProvider.filter = this.adjustmentsOdata.prefilter;
            } else {
              this.$refs.adjTable.getDataAsync();
            }
            break;
          }
          case 4: {
            this.unlock();
            this.$nextTick(() => {
              this.$refs.getReports.reset();
            });
            break;
          }
        }
      },
    },
    selectedPlan: {
      handler() {
        this.loadPlanData();
      },
    },
  },
  mounted() {
    if (this.selectedPlan !== null && this.selectedPlan !== undefined) {
      this.loadPlanData();
    }
  },
  methods: {
    trans(item, field) {
      return translate2(item, field);
    },
    /*$t(args) {
        console.log(this.messages, args)
        if (Object.keys(this.messages).indexOf(args) < 0) {
            this.messages[args]="TRANSLATION REQUIRED"
        }
        return "TRANSLATION REQUIRED";
    },*/
    ...mapActions("plansMembers", [
      "getCurrentTerm",
      "getMembersBillingWizardColumns",
    ]),
    ...mapActions("common", ["createOdataType"]),
    ...mapActions("transactions", [
      "postAdjustmentAction",
      "calculate",
      "adjustmentsExist",
      "getAdjustments",
    ]),
    async skipCalculation() {
      let result = await this.tryCalculate(true);
      if (result) {
        this.$router.push({
        name: "billing",
        params: { planId: this.selectedPlan.Id },
      });
      }
    },
    async loadPlanData() {
      if (this.selectedPlan !== null || this.selectedPlan !== undefined) {
        try {
          this.term = await this.lock(
            this.getCurrentTerm,
            this.selectedPlan.Id,
            () => {
              this.$router.push({
                name: "billing",
                params: { planId: this.selectedPlan.Id },
              });
            }
          );

          let mHeaders = (
            await this.getMembersBillingWizardColumns(this.selectedPlan.Id)
          ).data.sort((a, b) => {
            return a.order - b.order;
          });
          this.membersForTermHeaders = this.$helpers.createOdataHeaders(
            mHeaders.filter((h) => h.showOnExpandOnly !== true),
            "headers.members_wizard."
          );
        } catch (error) {
          this.error = error;
        }
      }
    },
    formatErrors(errors) {
      var formattedErrors = {};
      if (errors) {
        errors.forEach((e) => {
          e.Errors.forEach(function (errStr) {
            if (formattedErrors[errStr] != null) {
              formattedErrors[errStr].push(e.Line);
            } else {
              formattedErrors[errStr] = [e.Line];
            }
          });
        });
        return formattedErrors;
      }
    },
    async setAdjustments(items) {
      let adj = (
        await this.getAdjustments({
          plan: this.selectedPlan.Id,
          term: this.term.Id,
        })
      ).data.value;
      //console.log(items, adj);
      if (adj) {
        this.hasPendingAdjustments = adj.length > 0;
      } else this.hasPendingAdjustments = false;
    },
    setMembersForTerm(items) {
      this.membersForTerm = items && items.length > 0;
      this.loaded = true;
    },
    finish() {
      /*this.e6 = 1;
      this.calculateMessage = "";
      this.calculateIcon="";
      this.calculateColor=success;*/
      this.$router.push({
        name: "billing",
        params: { planId: this.selectedPlan.Id },
      });
    },
    async tryCalculate(skip) {
      this.calculating = true;
      let result = false;
      try {
        this.reportId = (
          await this.calculate({
            plan: this.selectedPlan.Id,
            term: this.term.Id,
            skip: skip
          })
        ).data.value;
        this.calculated = true;
        this.calculateMessage = this.successMessage;
        // console.log(this.calculateMessage);
        this.calculateColor = "success";
        this.calculateIcon = "done";
        result = true;
      } catch (error) {
        // console.log(error);
        this.calculateMessage = this.failMessage;
        // console.log(this.calculateMessage);
        this.calculateColor = "error";
        this.calculateIcon = "error_outline";
      } finally {
        this.calculating = false;
      }
      return result;
    },
    async adjustmentActions(action) {
      // console.log(action, this.$refs.adjTable.selected);
      let adjToHandle = this.$refs.adjTable.selected.map((o) => o.Id);
      //alert("this would " + item + " the selected adjustments");
      try {
        this.saving = true;
        await this.postAdjustmentAction({
          plan: this.selectedPlan.Id,
          action: action,
          adjustments: adjToHandle,
          term: this.term,
        });
        this.saving = false;
        this.color = "success";
        let verb = "";
        switch (action) {
          case "approve":
            verb = "approved";
            break;
          case "reject":
            verb = "rejected";
            break;
          case "archive":
            verb = "archived";
            break;
          case "postpone":
            verb = "postponed";
            break;
        }
        if (adjToHandle.length > 1)
          this.message = adjToHandle.length + " adjustments were " + verb;
        else this.message = adjToHandle.length + " adjustment was " + verb;
        this.snackbar = true;
        this.$refs.adjTable.selected = [];
        this.$refs.adjTable.getDataAsync();
        // console.log("pending adj2: ", this.hasPendingAdjustments);
      } catch (error) {
        this.error = error;
      }
    },
    async adjustmentAction(item, action) {
      let adjToHandle = [item.Id];
      try {
        this.saving = true;
        await this.postAdjustmentAction({
          plan: this.selectedPlan.Id,
          action: action,
          adjustments: adjToHandle,
          term: this.term,
        });
        this.saving = false;
        this.color = "success";
        let verb = "";
        switch (action) {
          case "approve":
            verb = "approved";
            break;
          case "reject":
            verb = "rejected";
            break;
          case "archive":
            verb = "archived";
            break;
          case "postpone":
            verb = "postponed";
            break;
        }

        this.message = adjToHandle.length + " adjustment was " + verb;
        this.snackbar = true;
        this.$refs.adjTable.getDataAsync();
        // console.log("pending adj2: ", this.hasPendingAdjustments);
      } catch (error) {
        this.error = error;
      }
    },
    cancel() {
      this.dialog = false;
      /*this.e6 = 1;
      this.calculateMessage = "";
      this.calculateIcon = "";
      this.calculateColor = "success";
      */
      //this.unlock();
      this.$router.push({
        name: "billing",
        params: { planId: this.selectedPlan.Id },
      });
    },
  },
};
</script>

<style>
.with-margin {
  margin: 20px;
}
.background-red {
  background-color: red;
}
.background-green {
  background-color: green;
  color: white;
}
.v-stepper small {
  color: rgba(0, 0, 0, 0.54);
}
</style>
